<template>

  <div class="order" @click="handleChangeOrder">
      <template v-if="diaryWeeksOrder === 'asc'">
        <template v-if="firstWeek.faza === WeekFaza.Germination">
          <span>Start at Germination</span>
        </template>
        <template v-else>
          <span>Start at {{ firstWeek.days }} Week</span>
        </template>
        <i class="icon-sort-asc"></i>
      </template>
      <template v-else>
        <template v-if="lastWeek.faza === WeekFaza.Harvest">
          <span>Start at Harvest</span>
        </template>
        <template v-else>
          <span>Start at {{ lastWeek.days }} Week</span>
        </template>
        <i class="icon-sort-desc"></i>
      </template>
  </div>
  
</template>

<script setup lang="ts">

import type { Week } from '@/types/diary'
import { WeekFaza } from '@/types/diary'

const diaryWeeksOrder = useDiaryWeeksOrder()

const emits = defineEmits([
  'changeOrder',
])

interface PageProps {
  weeks?: Week[]
}
const props = defineProps<PageProps>()

const handleChangeOrder = () => {
  diaryWeeksOrder.value = diaryWeeksOrder.value === 'asc' ? 'desc' : 'asc'
  emits('changeOrder', diaryWeeksOrder.value)
}

const firstWeek = computed(() => {
  if (!props.weeks?.length) return
  return props.weeks[0]
})

const lastWeek = computed(() => {
  if (!props.weeks?.length) return
  return props.weeks[props.weeks.length - 1]
})


</script>

<style scoped>
.order{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: bold;
  gap: 0.5rem;
  width: fit-content;
  margin: 0 auto;
  margin-right: 0;
  cursor: pointer;
  /* margin-top: 2rem; */
  margin-bottom: -2rem;

  width: 100%;
}
@container pb (max-width: 600px) {
  
}
 
</style>
